import React, { Component, Fragment } from 'react';
import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import AppURL from '../../api/AppURL';
import Login from '../../assets/images/login.png';
import axios from 'axios';
import { Navigate } from "react-router-dom";

class Register extends Component {

  constructor() {
    super();
      
    this.state = {
      name: '',
      email: '',
      password: '',
      password_confirmation: '',
      message: '',
      loggedIn: false
    };
  }

  // REGISTER FORM SUBMIT
  formSubmit = (e) => {

    e.preventDefault();

    const data = {
      name: this.state.name,
      email: this.state.email,
      password: this.state.password,
      password_confirmation: this.state.password_confirmation
    };

    axios.post(AppURL.UserRegister, data)

      

        
.then(response => {

    localStorage.setItem('token', response.data.token);

    this.props.setUser(response.data.user);

    this.setState({
        redirect: true
    });

       this.props.setUser(response.data.user);

      })





     .catch(error => {

    console.log(error.response);

    if(error.response){
        console.log(error.response.data);
        alert(JSON.stringify(error.response.data));
    }else{
        alert("Network Error");
    }

});

  }

  render() {

    

      if (this.state.redirect) {
    return <Navigate to="/profile" />
}



    return (

      <Fragment>

        <Container>

          <Row className="p-2">

            <Col
              className="shadow-sm bg-white mt-2"
              md={12}
              lg={12}
              sm={12}
              xs={12}
            >

              <Row className="align-items-center">

                {/* FORM SECTION */}
                <Col
                  className="d-flex justify-content-center"
                  md={6}
                  lg={6}
                  sm={12}
                  xs={12}
                >

                  <Form
                    className="onboardForm w-100 p-4"
                    onSubmit={this.formSubmit}
                  >

                    <h4 className="section-title-login text-center mb-4">
                      USER REGISTER
                    </h4>

                    <Form.Group className="mb-3">

                      <Form.Control
                        type="text"
                        placeholder="Enter Your Name"
                        onChange={(e) => {
                          this.setState({ name: e.target.value })
                        }}
                      />

                    </Form.Group>

                    <Form.Group className="mb-3">

                      <Form.Control
                        type="email"
                        placeholder="Enter Your Email"
                        onChange={(e) => {
                          this.setState({ email: e.target.value })
                        }}
                      />

                    </Form.Group>

                    <Form.Group className="mb-3">

                      <Form.Control
                        type="password"
                        placeholder="Enter Your Password"
                        onChange={(e) => {
                          this.setState({ password: e.target.value })
                        }}
                      />

                    </Form.Group>

                    <Form.Group className="mb-3">

                      <Form.Control
                        type="password"
                        placeholder="Confirm Your Password"
                        onChange={(e) => {
                          this.setState({
                            password_confirmation: e.target.value
                          })
                        }}
                      />

                    </Form.Group>

                    <Button
                      type="submit"
                      className="w-100 site-btn-login"
                    >
                      Sign Up
                    </Button>

                    <hr className="my-4" />

                    <p className="text-center">

                      <b>Forget My Password?</b>

                      <Link to="/forget">
                        <b> Forget Password</b>
                      </Link>

                    </p>

                    <p className="text-center">

                      <b>Already Have An Account?</b>

                      <Link to="/login">
                        <b> Login</b>
                      </Link>

                    </p>

                  </Form>

                </Col>

                {/* IMAGE SECTION */}
                <Col
                  className="p-0 text-center"
                  md={6}
                  lg={6}
                  sm={12}
                  xs={12}
                >

                  <img
                    className="img-fluid onboardBanner"
                    src={Login}
                    alt="register"
                  />

                </Col>

              </Row>

            </Col>

          </Row>

        </Container>

      </Fragment>

    );
  }
}

export default Register;